import { atom } from "jotai";

export const isTemplatePageAtom = atom(false);

isTemplatePageAtom.debugLabel = "isTemplatePageAtom";
